import './product-info.scss';
export default () => {
};
